import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=9d8cb7cc"
import script from "./actions.vue?vue&type=script&lang=ts"
export * from "./actions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports